// src/components/AboutConsultationSection.jsx
import React from "react";

/**
 * WhoYouWillTalkToSection
 *
 * Purpose:
 * - Credibility reassurance before contact
 * - Single-column, calm, advisory tone
 * - No agency language, no execution framing
 */

export default function AboutConsultationSection({
    photo = "/assets/anindya.png",
    brandName = "Buzz To Brand",
}) {
    return (
        <section
            id="who-you-will-talk-to"
            className="max-w-4xl mx-auto px-6 md:px-12 py-16 text-center"
            aria-label="Who you will be talking to"
        >
            {/* Section title */}
            <h2 className="text-3xl md:text-4xl font-semibold mb-6 text-[var(--text-primary)]">
                Who You’ll Be Talking To
            </h2>

            {/* Avatar */}
            <div className="flex justify-center mb-6">
                <img
                    src={photo}
                    alt="Portrait of Anindya Chowdhury"
                    loading="lazy"
                    width={120}
                    height={120}
                    className="w-28 h-28 rounded-full object-cover shadow-md border border-[rgba(26,30,46,0.08)]"
                />
            </div>

            {/* Name + title */}
            <p className="text-xl font-semibold text-[var(--text-primary)]">
                Anindya Chowdhury
            </p>
            <p className="text-sm text-[var(--text-secondary)] mb-6">
                Growth Consultant, {brandName}
            </p>

            {/* Core credibility paragraph */}
            <p
                className="text-base md:text-lg leading-relaxed text-justify mx-auto text-[var(--text-secondary)]"
                style={{ maxWidth: "55ch" }}
            >
                Anindya works with founders at moments where growth decisions matter most. Across growth, product, and sales, his focus stays the same: find the real problem, and solve it.
            </p>

            {/* Light credibility line */}
            <p className="mt-4 text-md text-slate-500">
                Previously worked with ICICI Bank, Country Delight, and Nurturing Green.
                <br />
                Has also founded and run his own businesses.
            </p>

            {/* Metadata */}
            <div className="mt-6 flex justify-center gap-8 text-sm text-slate-600">
                <span>8+ years experience</span>
                <span>MBA, IIM Rohtak</span>
            </div>

            {/* LinkedIn */}
            <div className="mt-6">
                <a
                    href="https://www.linkedin.com/in/anindya114/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm hover:opacity-90 transition"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="text-[#0A66C2]"
                        aria-hidden="true"
                    >
                        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764c.967 0 1.75.79 1.75 1.764s-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-1.337-.027-3.059-1.865-3.059-1.867 0-2.153 1.459-2.153 2.968v5.695h-3v-11h2.879v1.507h.041c.401-.758 1.379-1.559 2.84-1.559 3.04 0 3.605 2.003 3.605 4.609v6.443z" />
                    </svg>
                    <span>Connect on LinkedIn</span>
                </a>
            </div>
        </section>
    );
}
